import React, { ComponentType } from 'react';

interface WithIsMobile {
  isMobile: boolean;
}

type ForDevice = <
  MobileProps extends WithIsMobile,
  DesktopProps extends WithIsMobile
>(
  MobileComponent: ComponentType<MobileProps>,
  DesktopComponent: ComponentType<DesktopProps>,
) => ComponentType<DesktopProps & MobileProps>;

const forDevice: ForDevice = (MobileComponent, DesktopComponent) => (props) =>
  props.isMobile ? (
    <MobileComponent {...props} />
  ) : (
    <DesktopComponent {...props} />
  );

export default forDevice;
